import { Download, Trash } from "@phosphor-icons/react";
import { useModal } from "context/ModalContext";
import { set } from "date-fns";
import { Button, Textarea } from "flowbite-react";
import { useCallback, useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import ReactModal from "react-modal";
import { actionLog } from "services/actionlog.service";
import { getFriends, getListOfFriends } from "services/friends.service";
import { clearNotifications } from "services/notifications.service";
import {
  getRealLifeLog,
  submitRealLifeMission,
} from "services/reallife.service";
import { uploadFile } from "services/upload.service";
import { nl2br } from "services/utils";
import { useAppStore } from "store";

export default function RealLifeReviewModal() {
  ReactModal.setAppElement("#modal");

  const modalID = "real-life-review";
  const { user, host, pointsHistory } = useAppStore();
  const [modalIsOpen, setIsOpen] = useState(false);
  const { showModal, openModal, closeModal, modalData } = useModal();

  const [loading, setLoading] = useState(false);

  const [answers, setAnswers] = useState<any>([]);

  const [friends, setFriends] = useState<any>([]);

  function afterOpenModal() {}

  const handleCloseModal = useCallback(() => {
    closeModal();
    setAnswers([]);
    setFriends([]);
    setLoading(false);
  }, [closeModal]);

  const loadData = useCallback(async () => {
    try {
      if (!modalData) return;

      setLoading(true);

      let listOfAnswers: any = [];

      // GET USER ANSWERS
      const result = await getRealLifeLog(modalData._id, user?._id);
      listOfAnswers = result;

      // GET FRIENDS ANSWERS

      const friendsList = await getListOfFriends(user?._id);
      const missionFriends = friendsList.filter((friend: any) =>
        friend.missions.find((m: any) => m.mission === modalData._id),
      );

      let friendsDataRequest: any = [];

      setFriends(missionFriends);

      missionFriends.forEach((friend: any) => {
        friendsDataRequest.push(getRealLifeLog(modalData._id, friend._id));
      });

      const friendsData = await Promise.all(friendsDataRequest);

      friendsData.forEach((friendResult: any) => {
        friendResult.forEach((friend: any) => {
          listOfAnswers = [
            ...listOfAnswers,
            {
              ...friend,
              player: missionFriends.find((f: any) => f._id === friend.player)
                .name,
            },
          ];
        });
      });

      setAnswers(listOfAnswers);

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, [modalData, user]);

  const loadFriendsData = useCallback(async () => {
    try {
      if (!modalData) return;
      const friendsList = await getListOfFriends(user?._id);
      const missionFriends = friendsList.filter((friend: any) =>
        friend.missions.find((m: any) => m.mission === modalData._id),
      );

      setFriends(missionFriends);

      // const result = await getRealLifeLog(modalData._id, user?._id);
      //setAnswers(result);
    } catch (e) {
      console.log(e);
    }
  }, [modalData, user]);

  useEffect(() => {
    if (openModal === modalID) {
      setIsOpen(true);
      loadData();
    } else {
      setIsOpen(false);
    }
  }, [openModal, modalData, loadData, loadFriendsData]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Badge Modal"
        portalClassName="relative z-40"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="bg-white rounded-xl p-3 md:px-5 w-[450px] max-w-[97vw] max-h-[80vh] flex flex-col items-center flex-none mx-5 gap-1 overflow-y-auto">
              <h1 className="text-xl lg:text-3xl mt-2 font-bold text-blue-500 text-center">
                ¡Respuestas Vida Real!
              </h1>
              <small>Ver las respuestas que enviaste a esta misión</small>
              {!loading ? (
                <>
                  <div className="w-full flex flex-col gap-3">
                    <p className="text-center text-lg font-bold">
                      {modalData?.title}
                    </p>
                    {answers?.map((answer: any, index: number) => (
                      <div
                        key={index}
                        className="border p-3 rounded-xl flex flex-col gap-3"
                      >
                        {answer.message ? (
                          <div>
                            {answer.player === user?._id ? (
                              <p className="text-brand-blue font-bold text-sm">
                                Usted:
                              </p>
                            ) : (
                              <p className="text-brand-red font-bold text-sm">
                                {answer.player}:
                              </p>
                            )}

                            <div
                              dangerouslySetInnerHTML={{
                                __html: nl2br(answer.message),
                              }}
                            ></div>
                          </div>
                        ) : null}

                        {answer.image && answer.image.url ? (
                          <div>
                            {answer.player === user?._id ? (
                              <p className="text-brand-blue font-bold text-sm">
                                Usted:
                              </p>
                            ) : (
                              <p className="text-brand-red font-bold text-sm">
                                {answer.player}:
                              </p>
                            )}
                            <img
                              src={answer.image.url}
                              alt="answer"
                              className="w-full rounded-lg mx-auto object-contain object-center h-40 bg-gray-100"
                            />
                          </div>
                        ) : null}
                        {answer.file && answer.file.url ? (
                          <div>
                            {answer.player === user?._id ? (
                              <p className="text-brand-blue font-bold text-sm">
                                Usted:
                              </p>
                            ) : (
                              <p className="text-brand-red font-bold text-sm">
                                {answer.player}:
                              </p>
                            )}
                            <div className="flex items-center justify-between">
                              <a
                                href={answer.file.url}
                                target="_blank"
                                rel="noreferrer"
                                className="bg-brand-green w-full block p-3 rounded gap-3 flex items-center justify-center text-white font-bold underline "
                              >
                                <Download size={24} />
                                <span>Descargar archivo</span>
                              </a>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div>
                  <p>CARGANDO...</p>
                </div>
              )}
              <Button className="mt-5 bg-brand-red" onClick={handleCloseModal}>
                CERRAR
              </Button>
            </div>
          </div>
        )}
      />
    </>
  );
}
